/** The API answered 409 RESOURCE_BUSY: a short row-lock wait gave up behind a longer step. */
export const RESOURCE_BUSY_EVENT = 'api_resource_busy';

export const isResourceBusyError = (error: unknown): boolean => (
  (error as { code?: unknown } | null)?.code === 'RESOURCE_BUSY'
);

/** Show the server's "busy, try again in a moment" text, even where the caller swallows the failure. */
export const announceResourceBusy = (error: unknown): void => {
  const message = (error as { message?: unknown } | null)?.message;

  if (!isResourceBusyError(error) || typeof message !== 'string' || !message.trim()) return;
  window.dispatchEvent(new globalThis.CustomEvent(RESOURCE_BUSY_EVENT, { detail: { message: message.trim() } }));
};
